module.exports = __webpack_public_path__ + "img/skills-berserker-barb-1.5df1a26d.png";